import Axios from "axios";

const root = window.location.hostname.split(".");

export const getAxios = () => {
  return Axios.create({
    baseURL: `https://api.${root[0]==="localhost"?"devbarest":root[0]}.ir/user/`,
    headers: {
      "x-auth-token": localStorage.getItem("JwtTokens"),
    },
  });
};
export const AxiosRequest = () => {
  return Axios.create({
    baseURL: `https://api.${root[0]==="localhost"?"devbarest":root[0]}.ir/produt`,
    headers: {
      "x-auth-token": localStorage.getItem("JwtTokens"),
    },
  });
};
export const AxiosCategory = () => {
  return Axios.create({
    baseURL: `https://api.${root[0]==="localhost"?"devbarest":root[0]}.ir/category`,
    headers: {
      "x-auth-token": localStorage.getItem("JwtTokens"),
    },
  });
};
export const getAxiosTotall = () => {
  return Axios.create({
    baseURL: `https://api.${root[0]==="localhost"?"devbarest":root[0]}.ir/`,
    headers: {
      "x-auth-token": localStorage.getItem("JwtTokens"),
    },
  })
}
